import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { STUDIO } from "@/lib/api";

const KEY = "santarelli_preloaded";

/** Velo di ingresso: logo, linea oro, dissolvenza. Solo alla prima visita della sessione. */
export const Preloader = () => {
  const [show, setShow] = useState(() => {
    if (typeof window === "undefined") return false;
    if (sessionStorage.getItem(KEY)) return false;
    return !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  });

  useEffect(() => {
    if (!show) return;
    sessionStorage.setItem(KEY, "1");
    document.body.style.overflow = "hidden";
    const t = setTimeout(() => setShow(false), 1200);
    return () => { clearTimeout(t); document.body.style.overflow = ""; };
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="fixed inset-0 z-[200] bg-ivory flex flex-col items-center justify-center gap-8 px-8"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, y: "-100%" }}
          transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
          data-testid="preloader"
        >
          <motion.img src="/brand/logo-grey.webp" alt={STUDIO.brand} className="h-11 sm:h-12 w-auto"
            initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: "easeOut" }} />
          <div className="w-44 sm:w-56 h-px bg-line overflow-hidden">
            <motion.div className="h-full bg-oro" initial={{ width: 0 }} animate={{ width: "100%" }} transition={{ duration: 1.1, ease: [0.4, 0, 0.2, 1] }} />
          </div>
          <motion.p className="text-[10.5px] uppercase tracking-[0.26em] text-mute"
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.7, delay: 0.25 }}>
            Fotografi dal 1982 · L'Aquila
          </motion.p>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
